module.exports = __webpack_public_path__ + "static/mongodb-e1a781bda0165109cb61f34e4ab11df7.svg";